export default __webpack_public_path__ + "static/media/photo--sm--janie2.687d9f9f.jpg";